import e from "react";
import r from "prop-types";
import R from "classnames";
import l from "./Grid/index.es.js";
import { I as g } from "./Icon-BuIPTPJn.es.js";
import { T as i } from "./index-Dd-4N6BE.es.js";
import { d as I } from "./deprecate-Dt6BL0Y6.es.js";
import E from "react-truncate";
import { N as h } from "./NoClickOutline-CllwvnB9.es.js";
import { d as N, u as T } from "./useDevice-BnuqUqDt.es.js";
import './ImageRow.css';const C = "ImageRow-module__grid___gqAHV", b = "ImageRow-module__gridCol___hhpbd", f = "ImageRow-module__imageCTA___wmRF-", v = "ImageRow-module__container___X35LL", q = "ImageRow-module__card___Rbqlu", y = "ImageRow-module__title___ZQnJ3", A = "ImageRow-module__section___YK7wE", S = "ImageRow-module__withSubtitle___XZymM", x = "ImageRow-module__rowTitle___YwF7H", k = "ImageRow-module__rowSubtitle___eN-Q0", H = "ImageRow-module__arrowIcon___NYjDH", P = "ImageRow-module__seeAll___hQhBN", t = {
  grid: C,
  gridCol: b,
  imageCTA: f,
  container: v,
  card: q,
  title: y,
  section: A,
  withSubtitle: S,
  rowTitle: x,
  rowSubtitle: k,
  arrowIcon: H,
  seeAll: P
}, w = ({ device: a, imageUrl: n, title: s, ctaText: m, ctaUrl: c }) => {
  const o = ["xs", "mobile"].includes(a) ? i.Heading6 : i.Heading5;
  return /* @__PURE__ */ e.createElement(h.Anchor, { href: c, className: t.container }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: t.card,
      style: { backgroundImage: `url("${n}")` }
    },
    /* @__PURE__ */ e.createElement("div", { className: t.imageCTA }, /* @__PURE__ */ e.createElement(o, null, m, /* @__PURE__ */ e.createElement(
      g,
      {
        name: "arrow_right_double",
        size: 20,
        className: t.arrowIcon,
        color: "currentColor"
      }
    )))
  ), /* @__PURE__ */ e.createElement("div", { className: t.title }, /* @__PURE__ */ e.createElement(o, { tagName: "div" }, /* @__PURE__ */ e.createElement(E, { lines: 2 }, s))));
}, p = {
  /** Destination link of the image when clicked */
  ctaUrl: r.string.isRequired,
  /** Text that appears when image is hovered */
  ctaText: r.string.isRequired,
  /** Href of the hosted image */
  imageUrl: r.string.isRequired,
  /** Text to appear below the image */
  title: r.string.isRequired
};
w.propTypes = {
  ...p,
  device: N.isRequired
};
const u = {
  xs: 2,
  mobile: 2,
  tablet: 4,
  laptop: 6,
  desktop: 6,
  largeDesktop: 6
}, d = ({ subtitle: a, title: n, images: s, ctaUrl: m, ctaText: c }) => {
  const o = T();
  return !!s.length && /* @__PURE__ */ e.createElement(
    l.Col,
    {
      width: 12,
      className: R(
        t.section,
        a && t.withSubtitle
      )
    },
    /* @__PURE__ */ e.createElement("section", null, /* @__PURE__ */ e.createElement(l, { nested: !0, className: t.grid }, /* @__PURE__ */ e.createElement(l.Row, null, /* @__PURE__ */ e.createElement(l.Col, { width: 12 }, /* @__PURE__ */ e.createElement("div", { className: t.rowTitle }, /* @__PURE__ */ e.createElement(i.Heading4, { responsive: !0 }, n)), a && /* @__PURE__ */ e.createElement("div", { className: t.rowSubtitle }, /* @__PURE__ */ e.createElement(i.Body, { responsive: !0 }, a)), /* @__PURE__ */ e.createElement(i.Body2, { responsive: !0 }, /* @__PURE__ */ e.createElement("div", { className: t.seeAll }, /* @__PURE__ */ e.createElement("a", { href: m }, c, /* @__PURE__ */ e.createElement(
      g,
      {
        name: "arrow_right_double",
        size: 20,
        className: t.arrowIcon,
        color: "currentColor"
      }
    ))))), s.slice(0, u[o]).map((_) => /* @__PURE__ */ e.createElement(
      l.Col,
      {
        key: _.title,
        width: 12 / u[o],
        className: t.gridCol
      },
      /* @__PURE__ */ e.createElement(
        w,
        {
          device: o,
          ..._
        }
      )
    )))))
  );
};
d.propTypes = {
  /** Text of the overall call to action */
  ctaText: r.string.isRequired,
  /** Destination link of the overall call to action */
  ctaUrl: r.string.isRequired,
  /** Array of `ImageShape` objects which form the images (all required) */
  images: r.arrayOf(r.shape(p)).isRequired,
  /** Text of the header above the image row */
  title: r.string.isRequired,
  /** More detailed description, displayed under the title */
  subtitle: r.string
};
d.defaultProps = {
  subtitle: null
};
const O = I(
  "The ImageRow component is deprecated and will be removed in the next major release."
)(d);
export {
  O as D
};
